import { Buffer } from "buffer";

export const parseBase64 = (data, parse = true) => {
  try {
    if (parse) {
      return data?.match(/(?<=base64,).*$/)?.[0] || data;
    }
    return data;
  } catch (err) {
    return data;
  }
};

export const fileToBase64 = (file, parse = true) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(parseBase64(reader.result, parse));
    reader.onerror = (err) => reject(err);
  });

export const fromBase64 = (data, format = "utf8") => {
  try {
    return Buffer.from(data, "base64").toString(format);
  } catch (err) {
    return null;
  }
};

export const getFileExt = (name = "") => {
  return name.split(".").at(-1);
};
